module.exports = __webpack_public_path__ + "static/media/sub_menu_skincare_pro_black.52ec31e0.png";